module.exports = __webpack_public_path__ + "h5/img/dsh.f74c6192.png";